type CurrencyPaymentPeriodValue = string | null | undefined;

export function formatCurrencyPaymentPeriod(
  currency: CurrencyPaymentPeriodValue,
  paymentPeriod: CurrencyPaymentPeriodValue
): string {
  const normalizedCurrency = currency?.trim();
  const normalizedPaymentPeriod = paymentPeriod?.trim();

  if (!normalizedCurrency) {
    return '';
  }

  return normalizedPaymentPeriod
    ? `${normalizedCurrency}/${normalizedPaymentPeriod}`
    : normalizedCurrency;
}
